import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import SocialLinks from 'admin-moderator/components/SocialLinks';

import Avatar from 'components/Avatar';
import Name from 'styled/ItemCard/Name';
import SimpleLink from 'styled/SimpleLink';
import UserItemRow from 'styled/UserItemRow';

export class ProfileItem extends React.PureComponent {
  get selected() {
    if (!this.props.history || !this.props.history.location || !this.props.history.location.pathname) return false;

    return this.props.history.location.pathname.indexOf(this.props.id) !== -1;
  }

  render() {
    return (
      <UserItemRow selected={this.selected}>
        <SimpleLink to={`/biller/profiles/status/${this.props.match.params.status}/${this.props.id}/user/${this.props.userId}`}>
          <Avatar
            size="56px"
            name={this.props.name}
            fontSize="18px"
            url={this.props.avatar}
          />
        </SimpleLink>

        <div style={{ marginLeft: '16px', marginTop: '7px' }}>
          <SimpleLink to={`/biller/profiles/status/${this.props.match.params.status}/${this.props.id}/user/${this.props.userId}`}>
            <Name style={{ marginRight: '40px' }}>{this.props.name}</Name>
          </SimpleLink>

          {this.props.socialLinks && (
            <SocialLinks socialLinks={this.props.socialLinks} />
          )}
        </div>
      </UserItemRow>
    );
  }
}

ProfileItem.propTypes = {
  id: PropTypes.string,
  userId: PropTypes.string,
  name: PropTypes.string,
  avatar: PropTypes.string,
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.string,
    socialLink: PropTypes.string,
  })),
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      status: PropTypes.oneOf(['created', 'accepted', 'rejected']),
    }),
  }).isRequired,
};

ProfileItem.defaultProps = {
  id: '',
  userId: '',
  name: '',
  avatar: '',
  socialLinks: [],
  history: {},
};

export default withRouter(ProfileItem);
